<div class="topbar">
  <div>
    <h1>Indstillinger for Partner</h1>
  </div>
  <div class="topbar__actions">
    <app-partner-list-filter [filter]="filter" (filterChange)="filterChange()" class="filter-flex"></app-partner-list-filter>
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret partner">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret partner</span>
      </button>
    }
  </div>
</div>
<div class="page__content settings">
  <table mat-table [dataSource]="partnereSortedByName" class="mat-elevation-z0 settings__table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let row">
        {{ row.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerNo">
      <th mat-header-cell *matHeaderCellDef>Partner nr.</th>
      <td mat-cell *matCellDef="let row">
        {{ row.partnerNo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Telefon</th>
      <td mat-cell *matCellDef="let row">
        {{ row.phone }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let row">
        {{ row.email }}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Aktiv</th>
      <td mat-cell *matCellDef="let row">
        {{ row.active ? 'Ja' : 'Nej' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="customerCount">
      <th mat-header-cell *matHeaderCellDef>Antal aftaler</th>
      <td mat-cell *matCellDef="let row">
        {{ row.partnerCustomerCount?.numberOfAgreements }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="hidden-cell">
          @if (canEdit) {
            <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger partner" matTooltip="Rediger partner">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          }
          @if (row.partnerCustomerCount?.numberOfAgreements > 0) {
            <button
              [routerLink]="['/partnerchange', row.partnerNo]"
              class="btn-icon blue"
              aria-label="Rediger partner"
              matTooltip="Gå til masseskift af partnerens aftaler"
              >
              <mat-icon svgIcon="swap"></mat-icon>
            </button>
          }
          <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
            <mat-icon>timeline</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
